package feature.product.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class ProductPrice(
    @SerialName("HSN") var hsn: String? = null,
    @SerialName("TaxIncluded") var taxIncluded: Boolean? = null,
    @SerialName("SGST") var SGST: Float? = null,
    @SerialName("CGST") var CGST: Float? = null,
    @SerialName("IGST") var IGST: Float? = null,
    @SerialName("CESS") var CESS: Float? = null,
    @SerialName("VAT") var VAT: Float? = null,
    @SerialName("OtherTax") var OtherTax: Float? = null,
    @SerialName("Discount") var Discount: Float? = null,
    @SerialName("MRP") var MRP: Float? = null,
    @SerialName("Price") var Price: Float? = null,
    @SerialName("CostPrice") var CostPrice: Float? = null,
    @SerialName("FinalPrice") var FinalPrice: Float? = null,
    @SerialName("Tax") var Tax: Float? = null,
    @SerialName("CreatedAt") var CreatedAt: String? = null,
    @SerialName("UpdatedAt") var UpdatedAt: String? = null,
    @SerialName("__v") var _v: Int? = null
)